import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ProgrammeSearch from '../components/ProgrammeSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;
        let findQuery = this.el.dataset.query;
        let tags = this.el.dataset.tags;
        let target = this.el.dataset.target;

        // decode json tags
        tags = JSON.parse(tags);
        tags = tags.map(tag => tag.id).join(',');

        const app = createApp({
            template: '<ProgrammeSearch etiquettes="'+tags+'" background="'+findBackground+'" target="'+target+'" query="'+findQuery+'" />',
            components: {
                ProgrammeSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}